import React, { useEffect, useState } from 'react'
import styles from './EditDate.module.scss'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormDateSelector from 'components/UI/AsideModal/Form/FormDateSelector'
import { dateFormat } from 'helpers/date'
import { observer } from 'mobx-react'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import DatePicker from 'react-datepicker'
import { timeConverter } from 'components/ContentBox//Online-schedule/components/functions'
import { addZero } from 'helpers/math'
import useLocalization from 'hooks/useLocalization'
import { dict, translate as loc } from 'Localisation'
import { localisationMaster } from 'Localisation/Localisation'
import SelectCustom from '../../../../Select/SelectCustom'
import { superAxiosRequest } from 'axiosApi'

const EditDate = ({ addTaskFromDeal }) => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
  } = asideModalStore
  const [taskCategory, setTaskCategory] = useState([])
  const [executors, setExecutors] = useState([])

  const [isDisabled, setIsDisabled] = useState(true)

  const { translate } = useLocalization({
    section: 'Crm_tasks',
    subsection: 'task',
    dict: {
      transaction_buyer: 'Contact, transaction buyer',
      task_type: 'Task type',
      name: 'Name',
      executor: 'Executor',
      start_finish_time: 'Start & Finish Time',
      start_date: 'Start Date',
      end_date: 'End Date',
      modal_title_add_task: 'Add a new task',
      start: 'Start',
      end: 'End',
      period: 'Period',
      date: 'Date',
    },
  })

  const [initialDateTime, setInitialDateTime] = useState({
    date: new Date(),
    startTime: new Date('2020-01-01T06:00:00'),
    endTime: new Date('2020-01-01T23:00:00'),
  })

  useEffect(() => {
    if (modalValue.finish_task && modalValue.start_task) {
      const finishDate = new Date(modalValue.finish_task)
      const startDate = new Date(modalValue.start_task)
      const dateOnly = new Date(finishDate.toISOString().split('T')[0])

      const startHours = startDate.getHours()
      const startMinutes = startDate.getMinutes()
      const startSeconds = startDate.getSeconds()

      const finishHours = finishDate.getHours()
      const finishMinutes = finishDate.getMinutes()
      const finishSeconds = finishDate.getSeconds()

      setInitialDateTime({
        date: dateOnly,
        startTime: new Date(
          `2020-01-01T${addZero(startHours)}:${addZero(startMinutes)}:${addZero(startSeconds)}`,
        ),
        endTime: new Date(
          `2020-01-01T${addZero(finishHours)}:${addZero(finishMinutes)}:${addZero(finishSeconds)}`,
        ),
      })

      changeValues(dateFormat(dateOnly, 'YYYY-mm-dd'), 'date')
      changeValues(
        `${addZero(startHours)}:${addZero(startMinutes)}:${addZero(startSeconds)}`,
        'start_at',
      )
      changeValues(
        `${addZero(finishHours)}:${addZero(finishMinutes)}:${addZero(finishSeconds)}`,
        'finish_at',
      )
    }
  }, [modalValue.finish_task, modalValue.start_task])

  useEffect(() => {
    superAxiosRequest({
      method: 'get',
      link: 'tasktracker/task_categories',
      params: {},
      crm: true,
    })
      .then(({ data }) => {
        const categories = data?.result || []
        setTaskCategory(categories)

        const hasSelected = asideModalStore.modalValues?.task_category
        if (!hasSelected) {
          const defaultCategory = categories.find(
            (cat) => cat.id === 52 || cat.name === 'Contact',
          )
          if (defaultCategory) {
            changeValues(defaultCategory.id, 'task_category')
          }
        }
      })
      .catch(() => {})
      .finally(() => {
        setIsDisabled(false)
      })
  }, [])

  useEffect(() => {
    superAxiosRequest({
      method: 'get',
      link: 'integration/employees',
      params: {
        limit: 999,
        short_form: true,
      },
      crm: true,
    })
      .then(({ data }) => {
        setExecutors(data)

        const hasSelected = asideModalStore.modalValues?.assignee
        if (!hasSelected && addTaskFromDeal) {
          const managerId = asideModalStore.modalValues?.manager
          if (managerId && data.some((emp) => emp.id === managerId)) {
            changeValues(managerId, 'assignee')
          }
        }
      })
      .catch(() => {})
      .finally(() => {
        setIsDisabled(false)
      })
  }, [])

  const handleDateChange = (val) => {
    const formattedDate = dateFormat(val, 'YYYY-mm-dd')
    changeValues(formattedDate, 'date')
  }

  return (
    <div className={styles.groupForm}>
      <div className={styles.fieldSet}>
        <FormField>
          <FormLabel>{translate.start_finish_time}:</FormLabel>
          <FormInput>
            <div className={styles.datetimeBox}>
              <DatePicker
                selected={
                  modalValue.start_at
                    ? new Date('2020-01-01T' + modalValue.start_at)
                    : initialDateTime.startTime
                }
                onChange={(date) => {
                  changeValues(
                    timeConverter(date, 'time') +
                      `:${addZero(date.getSeconds())}`,
                    'start_at',
                  )
                }}
                onSelect={(date) => {
                  changeValues(
                    timeConverter(date, 'time') +
                      `:${addZero(date.getSeconds())}`,
                    'start_at',
                  )
                }}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                timeCaption={translate.start}
                timeFormat='HH:mm'
                dateFormat='HH:mm'
              />
              <div className={styles.datetimeBoxMiddle}>-</div>
              <DatePicker
                selected={
                  modalValue.finish_at
                    ? new Date('2020-01-01T' + modalValue.finish_at)
                    : initialDateTime.endTime
                }
                onChange={(date) => {
                  changeValues(
                    timeConverter(date, 'time') +
                      `:${addZero(date.getSeconds())}`,
                    'finish_at',
                  )
                }}
                onSelect={(date) => {
                  changeValues(
                    timeConverter(date, 'time') +
                      `:${addZero(date.getSeconds())}`,
                    'finish_at',
                  )
                }}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                timeCaption={translate.end}
                timeFormat='HH:mm'
                dateFormat='HH:mm'
              />
            </div>
          </FormInput>
        </FormField>

        <div className={styles.datePicker}>
          <FormLabel>{translate?.date}:</FormLabel>
          <div className={styles.dateSelector}>
            <FormDateSelector
              placeholder={translate.date}
              onChange={handleDateChange}
              value={
                modalValue?.date ||
                dateFormat(initialDateTime.date, 'YYYY-mm-dd')
              }
              error={check('date')}
            />
          </div>
        </div>
      </div>

      <FormField>
        <FormLabel isRequired>{translate.executor}:</FormLabel>
        <SelectCustom
          placeholder={translate.executor}
          options={executors}
          sortKey='name'
          valueID={modalValue?.assignee}
          onChange={(o) => changeValues(o.id, 'assignee')}
          isSearchable
          isDisabled={isDisabled}
          error={check('assignee')}
        />
      </FormField>

      <FormField>
        <FormLabel isRequired>{translate.task_type}:</FormLabel>
        <SelectCustom
          placeholder={translate.task_type}
          options={taskCategory}
          sortKey='name'
          isDisabled={isDisabled}
          isSearchable
          valueID={modalValue?.task_category}
          onChange={(o) => changeValues(o.id, 'task_category')}
          error={check('task_category')}
        />
      </FormField>

      <FormField>
        <FormLabel>{loc(dict.main_page.comment)}:</FormLabel>
        <FormInput>
          <textarea
            onChange={(e) => changeValues(e.target.value, 'comment')}
            value={modalValue.comment}
            placeholder={localisationMaster(
              'comment',
              'online-schedule/future-slots',
            )}
          />
        </FormInput>
      </FormField>
    </div>
  )
}

export default observer(EditDate)
